import React, { useMemo } from "react";
import "../Terms/Terms.css";
import { useLocalContext } from "../../context/LocalContext";

const ShippingPolicy = () => {
  const { webinfo = {} } = useLocalContext();

  const brand = useMemo(
    () => ({
      name: webinfo.name || "webantidigi.com",
      email: webinfo.email || "contact@webantidigi.com",
      phone: webinfo.phone || "+1 (000) 000-0000",
      phonecall: webinfo.phonecall || "+10000000000",
      address: webinfo.address || "United States",
    }),
    [webinfo]
  );

  const effectiveDate = useMemo(
    () =>
      new Date().toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }),
    []
  );

  return (
    <section className="terms">
      <div className="terms-wrap">
        <header className="terms-head">
          <span className="terms-kicker">Legal</span>
          <h1>Shipping &amp; Digital Delivery Policy</h1>
          <p className="terms-meta">
            <span>Provider: {brand.name}</span>
            <span>Last updated: {effectiveDate}</span>
            <span>Applicable to: United States</span>
          </p>
        </header>

        <div className="terms-content">
          <TermsBlock title="1. Delivery model">
            <p>
              Most orders are digital and delivered electronically (email, secure
              links, dashboard access, or repository delivery). Physical shipping
              applies only if clearly stated.
            </p>
          </TermsBlock>

          <TermsBlock title="2. Estimated delivery timeframe">
            <p>
              Delivery typically occurs after payment confirmation. Timing may vary
              based on verification checks, provider systems, and operational load.
            </p>
          </TermsBlock>

          <TermsBlock title="3. Potential delays">
            <ul>
              <li>Payment gateway verification</li>
              <li>Provider-side API or stock delays</li>
              <li>Maintenance or service interruptions</li>
              <li>Email filtering or anti-spam systems</li>
            </ul>
          </TermsBlock>

          <TermsBlock title="4. Customer responsibilities">
            <ul>
              <li>Provide accurate contact details at checkout</li>
              <li>Check spam/promotions folders for delivery emails</li>
              <li>Store delivered keys/files securely</li>
            </ul>
          </TermsBlock>

          <TermsBlock title="5. Missing delivery assistance">
            <p>
              If your order is not received in a reasonable time, contact{" "}
              <a href={`mailto:${brand.email}`}>{brand.email}</a> with your order
              details for review and support.
            </p>
          </TermsBlock>

          <TermsBlock title="6. Contact">
            <ul className="terms-contact">
              <li>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${brand.email}`}>{brand.email}</a>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <a href={`tel:${brand.phonecall}`}>{brand.phone}</a>
              </li>
              <li>
                <strong>Address:</strong> {brand.address}
              </li>
            </ul>
          </TermsBlock>
        </div>
      </div>
    </section>
  );
};

const TermsBlock = ({ title, children }) => (
  <section className="terms-card">
    <h2>{title}</h2>
    {children}
  </section>
);

export default ShippingPolicy;
